module.exports = __webpack_public_path__ + "static/img/J1.148e517.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SuperAce/J1.png
// module id = SlT4
// module chunks = 0